import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import '../css/Navbar.css';
import logo from '../../images/logo.png';

const Navbar = () => {
    // Inside your component
    const navigate = useNavigate();

    const handleServicesClick = (e) => {
        e.preventDefault(); // prevent default href behavior
        navigate('/services'); // navigate programmatically
    };

    const handleHriasClick = (e) => {
        e.preventDefault();
        navigate('/hrias-by-peregrinee');
    }
    return (
        <nav className="navbar navbar-expand-lg custom-navbar sticky-top px-4 shadow">
            <div className="container-fluid">
                <NavLink className="navbar-brand" to="/">
                    <img src={logo} alt="Logo" height="60" />
                </NavLink>

                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ms-auto align-items-center">
                        <li className="nav-item ms-4">
                            <NavLink className="nav-link" to="/">Home</NavLink>
                        </li>

                        <li className="nav-item dropdown ms-4 hrias-dropdown">
                            <a
                                className="nav-link dropdown-toggle"
                                href="/hrias-by-peregrinee"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                onClick={handleHriasClick}
                            >
                                Product - Hrias
                            </a>

                            <ul className="dropdown-menu">

                                <li><NavLink className="dropdown-item" to="/hrias-by-peregrinee">Hrias - Overview</NavLink></li>
                                {/* B2B Menu */}
                                <li className="dropdown-submenu">
                                    <a className="dropdown-item dropdown-toggle" href="#">Hrias for B2B</a>
                                    <ul className="dropdown-menu">
                                        <li><NavLink className="dropdown-item" to="/hrias-b2b-lead-database">90% Verified Lead Database - B2B</NavLink></li>
                                        {/* <li><NavLink className="dropdown-item" to="/hrias-email-finder-and-verifier">Email Finder & Verifier</NavLink></li>
                                        <li><NavLink className="dropdown-item" to="/hrias-phone-number-list">Verified Phone Number List</NavLink></li> */}
                                        <li><NavLink className="dropdown-item" to="/hrias-multi-channel-sequence">Multi-Channel Sequence</NavLink></li>
                                        <li><NavLink className="dropdown-item" to="/case-study-hrias-b2b">Case Study - B2B</NavLink></li>
                                        {/* <li><NavLink className="dropdown-item" to="/hrias-linkedin-prospecting">LinkedIn Prospecting</NavLink></li>
                                        <li><NavLink className="dropdown-item" to="/hrias-in-app-calling">In App Calling</NavLink></li>
                                        <li><NavLink className="dropdown-item" to="/hrias-whatsapp-prospecting">WhatsApp Prospecting</NavLink></li>
                                        <li><NavLink className="dropdown-item" to="/hrias-ai-personalization">AI Personalization</NavLink></li>
                                        <li><NavLink className="dropdown-item" to="/hrias-unified-inbox">Unified Inbox</NavLink></li> */}
                                        <li><NavLink className="dropdown-item" to="/hrias-b2b-pricing">Hrias - Pricing - B2B</NavLink></li>
                                    </ul>
                                </li>

                                {/* B2C Menu */}
                                <li className="dropdown-submenu">
                                    <a className="dropdown-item dropdown-toggle" href="#">Hrias For B2C</a>
                                    <ul className="dropdown-menu">
                                        <li><NavLink className="dropdown-item" to="/hrias-b2c-lead-database">90% Verified Lead Database - B2C</NavLink></li>
                                        {/* <li><NavLink className="dropdown-item" to="/hrias-facebook-prospecting">Facebook Prospecting</NavLink></li> */}
                                        <li><NavLink className="dropdown-item" to="/hrias-multi-channel-sequence-b2c">Multi Channel Sequence - B2C</NavLink></li>
                                        <li><NavLink className="dropdown-item" to="/case-study-hrias-b2c">Case Study - B2C</NavLink></li>
                                        <li><NavLink className="dropdown-item" to="/hrias-b2c-pricing">Hrias - Pricing - B2C</NavLink></li>
                                    </ul>
                                </li>
                            </ul>
                        </li>

                        <li className="nav-item ms-4">
                            <NavLink className="nav-link" to="/digital-marketing">Digital Marketing</NavLink>
                        </li>


                        {/* Services Dropdown */}
                        <li className="nav-item dropdown ms-4">
                            <a
                                className="nav-link dropdown-toggle"
                                href="/services"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                onClick={handleServicesClick}
                            >
                                IT Services
                            </a>
                            <ul className="dropdown-menu">
                                <li><NavLink className="dropdown-item" to="/custom-software-development">Custom Software Development</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/artificial-intelligence">Artificial Intelligence</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/ai-agent-development">AI Agent Development</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/minimum-viable-product">Minimum Viable Product (MVP)</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/website-and-app-development">Website and App Development</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/product-development">Product Development</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/enterprise-web-development">Enterprise Web Development</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/blockchain-development">Blockchain Development</NavLink></li>
                            </ul>
                        </li>



                        {/* Industries Dropdown */}
                        <li className="nav-item dropdown ms-4">
                            <a
                                className="nav-link dropdown-toggle"
                                href="#"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                Industries
                            </a>
                            <ul className="dropdown-menu">
                                <li><NavLink className="dropdown-item" to="/healthcare">Healthcare</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/fintech">Fintech & Insurtech</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/retail">Retail & E-commerce</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/entertainment-gaming">Entertainment & Gaming</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/media-communications">Media & Communications</NavLink></li>
                                {/* <li><NavLink className="dropdown-item" to="/industry2">Logistics</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/industry2">Real Estate & Construction</NavLink></li> */}
                            </ul>
                        </li>

                        {/* Other Menu Items */}
                        <li className="nav-item ms-4">
                            <NavLink className="nav-link" to="/offshore-development">Offshore Devs</NavLink>
                        </li>
                        <li className="nav-item ms-4">
                            <NavLink className="nav-link" to="/case-studies">Case Studies</NavLink>
                        </li>
                        <li className="nav-item ms-4">
                            <NavLink className="nav-link" to="/blogs">Blogs</NavLink>
                        </li>
                        <li className="nav-item ms-4">
                            <NavLink className="nav-link" to="/client-testimonials">Client Testimonials</NavLink>
                        </li>

                        {/* Contact Us Button */}
                        <li className="nav-item ms-4">
                            <NavLink
                                className="btn book-call-btn nav-link"
                                to="/contact-us"
                            >
                                Contact Us
                            </NavLink>

                        </li>
                        {/* <li className="nav-item ms-4">
                            <NavLink
                                className="btn book-call-btn nav-link"
                                to="/contact-us-hrias"
                            >
                                Contact Us Hrias
                            </NavLink>
                            
                        </li> */}
                    </ul>
                    {/* 👉 Add this below the <ul> list */}
                    <div className="d-lg-none mt-3 text-center">
                        <a href="mailto:info@peregrinee.com" className="btn btn-outline-primary me-2 mb-2 w-75">
                            📧 info@peregrinee.com
                        </a>
                        <a href="tel:+919875645936" className="btn btn-outline-success w-75">
                            📞 Call Us
                        </a>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
